import React from 'react'
import type { RecentMessageListRowProps } from './index'
import { htmlToPlainText } from '@ztechapps/common.utils'
import { Row } from '@ztechapps/webui.data-tools'
import { useRecentMessageContext } from './Context'
import { ChatMessageWidget } from '../ChatMessageWidget'

export const ListRow = (props: RecentMessageListRowProps) => {
  const context = useRecentMessageContext()

  const { selectedChatMessage, components } = context
  const { _id, plainContent, isPublic } = props
  const isSelected = selectedChatMessage?._id === _id

  return (
    <Row {...props}>
      <td style={{ wordBreak: 'break-all' }}>
        <ChatMessageWidget
          {...{
            ...props,
            isSelected,
            isPublic,
            message: htmlToPlainText(plainContent),
            actionComponent: <components.ListRowActions {...props} />,
          }}
        />
      </td>
    </Row>
  )
}
